/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 10c2.4853 0 4.5-2.0147 4.5-4.5S11.4853 1 9 1 4.5 3.0147 4.5 5.5 6.5147 10 9 10Zm0-1.5c1.6569 0 3-1.3431 3-3 0-1.6568-1.3431-3-3-3s-3 1.3432-3 3c0 1.6569 1.3431 3 3 3Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M13.0698 12.6323c.3441.2039.43.6538.2152.9912-.2317.3642-.7205.4545-1.096.2416C11.2045 13.3068 10.117 13 9 13c-3.544 0-6.7902 3.0882-7.3982 7.5h7.1484a.7498.7498 0 0 1 0 1.4996L0 22c0-.509.0311-1.0103.0911-1.5.624-5.0884 4.3749-9 8.9089-9 1.4646 0 2.8476.4082 4.0698 1.1323ZM22.385 14.6138a.7592.7592 0 0 0-.623-1.3846l-.737.3316a5.7833 5.7833 0 0 0-.9612-1.1788l.4721-.6551a.7592.7592 0 0 0-1.2318-.8876l-.4728.6561a5.8557 5.8557 0 0 0-1.4217-.5395l.0814-.8045a.7591.7591 0 1 0-1.5106-.1529l-.1528 1.5106a.759.759 0 0 0 .711.8343 4.3237 4.3237 0 0 1 2.0241.768l.0117.009.0141.0104a.7066.7066 0 0 0 .0275.0189 4.2822 4.2822 0 0 1 1.3805 1.7062 4.2819 4.2819 0 0 1 .3607 2.1672.7845.7845 0 0 0-.0062.0605 4.3224 4.3224 0 0 1-.7696 2.0285l-.0106.0139-.0073.0099a.8368.8368 0 0 0-.0177.0256 4.2817 4.2817 0 0 1-1.706 1.3819l-.0014.0006a4.2823 4.2823 0 0 1-2.1643.3611.6237.6237 0 0 0-.0338-.0042l-.0099-.0009-.007-.0006-.0158-.0011a4.3237 4.3237 0 0 1-2.023-.7676l-.0153-.0117-.0109-.008a.7592.7592 0 0 0-1.0598.172l-.8876 1.2318a.7593.7593 0 0 0 .172 1.0598.7593.7593 0 0 0 1.0598-.1721l.4727-.6561a5.8558 5.8558 0 0 0 1.4217.5394l-.0814.8046a.7591.7591 0 1 0 1.5106.1528l.0813-.8033a5.7815 5.7815 0 0 0 1.5012-.2445l.3316.737a.7592.7592 0 1 0 1.3846-.6229l-.3316-.7371a5.7789 5.7789 0 0 0 1.1789-.9611l.655.472a.759.759 0 1 0 .8876-1.2318l-.656-.4727a5.8507 5.8507 0 0 0 .5394-1.4217l.8045.0814a.7591.7591 0 0 0 .1529-1.5106l-.8033-.0813a5.7803 5.7803 0 0 0-.2446-1.5012l.7371-.3316Z"
    />
    <path
      fill="currentColor"
      d="M17.1677 15.9694c-.2138-.4752-.6582-.7753-1.145-.825a.7592.7592 0 0 1 .1541-1.5105c1.0038.1025 1.9304.7231 2.3756 1.7126.6636 1.4751.0058 3.2088-1.4693 3.8724-.9895.4452-2.0946.295-2.9137-.2943a.7592.7592 0 0 1 .8867-1.2325c.3972.2857.9289.356 1.4041.1422.7103-.3196 1.0271-1.1545.7075-1.8649Z"
    />
  </React.Fragment>,
  'MenuUserManagement'
);
